/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {DevilsCrossRoadGameAssets} from "../DevilsCrossRoadGameAssets";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {DevilsCrossRoadLayers, Layers} from "./DevilsCrossRoadLayers";

export class DCRoadBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundContainer:PIXI.Container;
    private _mainBG:PIXI.Sprite;
    private _backgroundFS:PIXI.Sprite;
    private _fsCandle: PIXI.spine.Spine;
    private _mainFrame:PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "DCRoadBackgroundElements";
        this.init();
    }

    public onOrientationChanged() {

    }

    public onResize() {

    }

    private createCandle():void {
        this._fsCandle = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("fsCandle"));
        //console.log("CANDLE: ANIM", this._fsCandle.state.data.skeletonData.animations);
        this._fsCandle.state.setAnimation(0, "idle", true);
        this._fsCandle.position.set(362, 358);
        this._fsCandle.visible = false;

        this.addChild(this._fsCandle);
    }

    public setMode(mode:string) {
        if(mode == DevilsCrossRoadGameMode.FREESPIN || mode == DevilsCrossRoadGameMode.SUPER_FREESPIN) {
            this._backgroundFS.visible = true;
            this._fsCandle.visible = true;
            this._mainBG.visible = false;
            this._mainFrame.state.setEmptyAnimation(0, 0);
            this._mainFrame.visible = false;
        } else if(mode == DevilsCrossRoadGameMode.NORMAL || mode == DevilsCrossRoadGameMode.NORMAL_AVALANCHE) {
            this._backgroundFS.visible = false;
            this._fsCandle.visible = false;
            this._mainBG.visible = true;
            this._mainFrame.visible = true;
            this.setMainFrame("glow_static", false);
        }
    }

    public setMainFrame(key:string, loop:boolean):null | PIXI.spine.core.TrackEntry {
        if(!this._mainFrame.visible) {
            return null;
        }
        const entry = this._mainFrame.state.setAnimation(0, key, loop);
        entry.mixDuration = 0.2;
        return entry;
    }

    private init() {
        this._backgroundContainer = new PIXI.Container();

        this._mainBG = new PIXI.Sprite(ImgLoader.getImgTexture("mainBackground")); //new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.MAIN_GAME_BACKGROUND)[0]);//new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("MainBG"));
        // this._mainBG = new PIXI.Sprite(GoingBananas.assetLoader.getTextures(GoingBananasGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._mainBG.position.set(360);
        this._mainBG.anchor.set(0.5, 0.5);
        this._mainBG.visible = true;

        const topLogo = new PIXI.Sprite(ImgLoader.getImgTexture("Logo"));
        topLogo.position.set(-206, -580);
        topLogo.scale.set(0.96);
        this._mainBG.addChild(topLogo);
        const leftLogo = new PIXI.Sprite(ImgLoader.getImgTexture("Logo"));
        leftLogo.position.set(-632, -304);
        leftLogo.scale.set(0.63);
        this._mainBG.addChild(leftLogo);

        this._backgroundFS = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.FS_BACKGROUND)[0]);
        this._backgroundFS.position.set(360, 360);
        this._backgroundFS.anchor.set(0.5, 0.5);

        this._backgroundContainer.addChild(this._backgroundFS);
        this._backgroundContainer.addChild(this._mainBG);
        this._backgroundContainer.position.set(0, 0);
        this.addChild(this._backgroundContainer);

        this.createCandle();

        this._mainFrame = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("mainReelFrame"));
        this._mainFrame.autoUpdate = true;
        this._mainFrame.position.set(360, 360);
        DevilsCrossRoadLayers.getLayer(Layers.MAIN_FRAME)?.addChild(this._mainFrame);
        this.setMainFrame("glow_static", false);

        this.onOrientationChanged();
        this.onResize();
    }
}